/**
 * Route for `android-app-links`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AndroidAppLinksPage } from "../features/android-app-links/AndroidAppLinksPage";

export const androidAppLinksRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/android-app-links",
	component: AndroidAppLinksPage,
});

export default androidAppLinksRoute;
